export const IS_SIDEBAR_COLLAPSED_BY_DEFAULT = false;
export const IS_THEME_DARK = false;
export default {};
